import './customChartTooltip.less'
import { ChartColors } from '../../../dashboards/mainDashboardv2/constants'
import { Typography } from '@lightbeamai/design-system'
import { useIntl } from 'react-intl'
import { TooltipProps } from 'recharts'
import React from 'react'

interface CustomTooltipProps extends TooltipProps<number, string> {
  title?: string
}

interface AdditionalInformation {
  label: string
  value: number
}

export const CustomTooltipCR = (props: CustomTooltipProps) => {
  const { active, payload, title } = props
  const intl = useIntl()

  const tooltipTitle = payload?.[0]?.payload?.name

  const totalValueCount = payload?.[0]?.payload?.value || 0

  const activeAdditionalInformation =
    payload?.[0]?.payload?.additionalData?.[tooltipTitle]?.domains || {}

  const additionalDataArray: AdditionalInformation[] = Object.keys(activeAdditionalInformation).map(
    (domain) => ({
      label: domain,
      value: activeAdditionalInformation[domain]
    })
  )

  const topAdditionalInformation = additionalDataArray
    ?.sort((a, b) => b.value - a.value)
    ?.slice(0, 4)

  const remainingValuesSum = additionalDataArray
    ?.slice(4)
    ?.reduce((sum, info) => sum + info.value, 0)

  if (active && payload && payload.length) {
    return (
      <div className="custom-colored-tooltip">
        {tooltipTitle && (
          <div className="tooltip-title-container">
            <div className="tooltip-title-with-color">
              <div
                className="tooltip-title-box"
                style={{ backgroundColor: ChartColors.Green }}
              ></div>
              <Typography className="truncate" type="medium" variant="baseMinus2" as="div">
                {tooltipTitle}
              </Typography>
            </div>

            <Typography as="div" color="primary" variant="baseMinus2" type="medium">
              {totalValueCount &&
                intl.formatNumber(totalValueCount || 0, {
                  notation: 'compact'
                })}
            </Typography>
          </div>
        )}
        {topAdditionalInformation && topAdditionalInformation.length > 0 ? (
          <>
            {topAdditionalInformation.map((additionalInformation, index) => (
              <div className="tooltip-item" key={index}>
                <div className="tooltip-item-label-container">
                  <Typography
                    as="div"
                    color="primary"
                    type="medium"
                    variant="baseMinus2"
                    className="truncate"
                  >
                    {additionalInformation.label}
                  </Typography>
                </div>

                <Typography as="div" color="primary" variant="baseMinus2" type="medium">
                  {intl.formatNumber(additionalInformation.value || 0, {
                    notation: 'compact'
                  })}
                </Typography>
              </div>
            ))}
            {remainingValuesSum > 0 && (
              <div className="tooltip-item">
                <Typography
                  as="div"
                  color="primary"
                  type="medium"
                  variant="baseMinus2"
                  className="truncate"
                >
                  {intl.formatMessage({ id: 'alert.assignType.others' })}
                </Typography>

                <Typography as="div" color="primary" variant="baseMinus2" type="medium">
                  {intl.formatNumber(remainingValuesSum || 0, {
                    notation: 'compact'
                  })}
                </Typography>
              </div>
            )}
          </>
        ) : (
          <div className="tooltip-item">
            <Typography as="div" color="primary" type="medium" variant="baseMinus2">
              {title}
            </Typography>

            <Typography as="div" color="primary" variant="baseMinus2" type="medium">
              {intl.formatNumber(totalValueCount || 0, {
                notation: 'compact'
              })}
            </Typography>
          </div>
        )}
      </div>
    )
  }

  return null
}

export const CustomTooltipCC = (props: CustomTooltipProps) => {
  const { active, payload } = props
  const intl = useIntl()

  const tooltipTitle = payload?.length !== 1 && payload?.[0]?.payload?.name

  const activeTooltip = payload?.find((data) => data.payload.hoveredBar === data.dataKey)

  if (active && payload && payload.length && activeTooltip) {
    return (
      <div className="custom-colored-tooltip">
        {tooltipTitle && (
          <div className="tooltip-title-container">
            <Typography
              className="tooltip-title-with-color"
              color="primary"
              type="medium"
              variant="baseMinus2"
              as="div"
            >
              {activeTooltip?.color && (
                <div
                  className="tooltip-title-box"
                  style={{ backgroundColor: activeTooltip?.color }}
                ></div>
              )}
              {activeTooltip?.dataKey}
            </Typography>

            <Typography as="div" color="primary" variant="baseMinus2" type="medium">
              {activeTooltip?.value &&
                intl.formatNumber(activeTooltip?.value || 0, {
                  notation: 'compact'
                })}
            </Typography>
          </div>
        )}
      </div>
    )
  }

  return null
}
